import { render, staticRenderFns } from "./FactoringDetail.vue?vue&type=template&id=216a3bc7&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./FactoringDetail.vue?vue&type=script&lang=js&"
export * from "./FactoringDetail.vue?vue&type=script&lang=js&"
import style0 from "./FactoringDetail.vue?vue&type=style&index=0&id=216a3bc7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216a3bc7",
  null
  
)

export default component.exports